import {Injectable} from '@angular/core';
import {GiftTicketReminder, GiftticketService as API, Response} from '../../generated/sales-terminal-client';
import {SnackService} from '../snack/snack.service';
import {Observable, tap} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GiftTicketService {

  constructor(private api: API,
              private snackService: SnackService) {}

  public updateGiftTickets(giftTicketReminder: GiftTicketReminder): Observable<Response> {
    return this.api.updateGiftTicketReminder(giftTicketReminder).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }
}
